// extracted by mini-css-extract-plugin
export default {"link":"link-with-icon_link__-yqZ7","icon":"link-with-icon_icon__Mr9jx"};